import { ReportAbilitiesContext } from 'src/app/providers/ReportsAbilitiesProvider';
import { useContext } from 'react';

const useReportAbilities = () => {
  const context = useContext(ReportAbilitiesContext);
  return context;
};

export default useReportAbilities;
